const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ================================================================
   SEATRX — cart drawer extras
   Trust badge · urgency line · "complete your set" upsell ·
   discount-code-to-checkout · real payment icons.
   Injected into Dawn's cart drawer and re-inserted after every
   re-render. No edits to theme.liquid / cart-drawer.liquid needed.

   >>> EDIT the DX block below to change copy / the SAMPLE rating. <<<
   Set DX.trust.sample = false (and real numbers) once real reviews
   are wired via Judge.me — do not publish the sample as genuine.
   ================================================================ */
(function () {
  var DX = {
    trust: {
      show: true,
      sample: false, // <- PREVIEW: label hidden per owner request 2026-09-23. MUST be true (or real Judge.me numbers) before publish — see CLAUDE.md rule 6 / PROGRESS.md.
      rating: '4.8',
      count: '1,240',
      word: 'reviews',
      sampleLabel: 'Sample — replace before publish',
    },
    urgency: {
      show: true,
      text: 'Your items aren’t reserved — check out soon so you don’t miss out.',
    },
    upsell: { show: true, heading: 'Complete your set' },
    discount: { show: true, heading: 'Discount code', placeholder: 'Enter code' },
    payments: { show: true },
  };

  // SeatRx "Complete Set" data (product 8365667123263). IDs are stable.
  var SET = { price: '$154.95', compare: '$204.90', save: 'Save $49.95' };
  var SET_BY_COLOUR = { Black: '43889488691263', Coffee: '43889488724031', Grey: '43889488756799' };
  var SET_IMG = {
    Black: 'https://cdn.shopify.com/s/files/1/0663/2872/3519/files/set-black.jpg?v=1789639911',
    Coffee: 'https://cdn.shopify.com/s/files/1/0663/2872/3519/files/set-coffee.jpg?v=1789639911',
    Grey: 'https://cdn.shopify.com/s/files/1/0663/2872/3519/files/set-grey.jpg?v=1789639911',
  };
  var SET_IDS = ['43889488691263', '43889488724031', '43889488756799'];
  var COLOUR = {
    '43889488691263': 'Black', '43889488724031': 'Coffee', '43889488756799': 'Grey',
    '43889488789567': 'Black', '43889488822335': 'Coffee', '43889488855103': 'Grey',
    '43889488887871': 'Black', '43889488920639': 'Coffee', '43889488953407': 'Grey',
  };

  var ICON_INFO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';
  var ICON_LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  function readState(drawer) {
    var rows = drawer.querySelectorAll('.cart-item'), colour = null, hasSet = false;
    [].forEach.call(rows, function (r) {
      var vb = r.querySelector('[data-variant-id]');
      var id = vb && vb.getAttribute('data-variant-id');
      if (id) { if (SET_IDS.indexOf(id) > -1) hasSet = true; if (!colour && COLOUR[id]) colour = COLOUR[id]; }
    });
    return { count: rows.length, hasSet: hasSet, colour: colour || 'Black' };
  }

  function stars() {
    var pct = Math.max(0, Math.min(100, (parseFloat(DX.trust.rating) / 5) * 100));
    return '<span class="dx-trust__stars"><span class="dx-trust__bg">★★★★★</span>' +
      '<span class="dx-trust__fg" style="width:' + pct + '%">★★★★★</span></span>';
  }

  function topEl() {
    var w = el('div', 'dx-ext dx-ext-top');
    if (DX.trust.show) {
      var t = el('div', 'dx-trust', stars() +
        '<span class="dx-trust__txt"><strong>' + esc(DX.trust.rating) + '</strong> · ' +
        esc(DX.trust.count) + ' ' + esc(DX.trust.word) + '</span>');
      if (DX.trust.sample) t.appendChild(el('span', 'dx-trust__sample', esc(DX.trust.sampleLabel)));
      w.appendChild(t);
    }
    if (DX.urgency.show) w.appendChild(el('div', 'dx-urge', ICON_INFO + '<span>' + esc(DX.urgency.text) + '</span>'));
    return w;
  }

  function offersEl(s) {
    var w = el('div', 'dx-ext dx-ext-offers');
    if (DX.upsell.show && !s.hasSet) {
      var col = SET_BY_COLOUR[s.colour] ? s.colour : 'Black';
      var vid = SET_BY_COLOUR[col], img = SET_IMG[col];
      w.appendChild(el('div', 'dx-upsell',
        '<p class="dx-upsell__h">' + esc(DX.upsell.heading) + '</p>' +
        '<div class="dx-upsell__card">' +
        '<img class="dx-upsell__img" src="' + img + '&width=160" alt="Complete Set ' + col + '" width="56" height="56" loading="lazy">' +
        '<div class="dx-upsell__info"><span class="dx-upsell__name">Complete Set · ' + col + '</span>' +
        '<span class="dx-upsell__price"><strong>' + SET.price + '</strong> <s>' + SET.compare + '</s> <em>' + SET.save + '</em></span></div>' +
        '<button type="button" class="dx-upsell__add" data-dx-add="' + vid + '">+ Add</button>' +
        '</div>'));
    }
    if (DX.discount.show) {
      var code = ''; try { code = sessionStorage.getItem('dx_discount') || ''; } catch (e) {}
      w.appendChild(el('div', 'dx-disc',
        '<p class="dx-disc__h">' + esc(DX.discount.heading) + '</p>' +
        '<div class="dx-disc__row"><input type="text" class="dx-disc__input" id="dx-disc-input" autocomplete="off" placeholder="' + esc(DX.discount.placeholder) + '" value="' + esc(code) + '">' +
        '<button type="button" class="dx-disc__btn" id="dx-disc-apply">Apply</button></div>' +
        '<p class="dx-disc__msg" id="dx-disc-msg"' + (code ? '' : ' hidden') + '>' + (code ? '“' + esc(code) + '” will be applied at checkout' : '') + '</p>'));
    }
    return w;
  }

  function payEl() {
    if (!DX.payments.show) return null;
    var w = el('div', 'dx-ext dx-ext-pay');
    var src = document.querySelector('.footer__payment .list-payment') || document.querySelector('.list-payment');
    if (src && src.children.length) w.appendChild(el('div', 'dx-pay', src.innerHTML));
    else w.appendChild(el('div', 'dx-pay dx-pay--secure', ICON_LOCK + '<span>Secure checkout</span>'));
    return w;
  }

  var obs = null;
  function inject(drawer) {
    if (!drawer) drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    if (obs) obs.disconnect();
    try {
      [].forEach.call(inner.querySelectorAll('.dx-ext'), function (n) { n.remove(); });
      var s = readState(drawer);
      if (s.count > 0) {
        var header = inner.querySelector('.drawer__header');
        if (header) header.insertAdjacentElement('afterend', topEl());
        var totals = inner.querySelector('.cart-drawer__footer');
        var footer = inner.querySelector('.drawer__footer');
        var offers = offersEl(s);
        if (totals && totals.parentNode) totals.parentNode.insertBefore(offers, totals);
        else if (footer) footer.insertBefore(offers, footer.firstChild);
        var ctas = inner.querySelector('.cart__ctas');
        var pay = payEl();
        if (pay && ctas) ctas.insertAdjacentElement('afterend', pay);
      }
    } finally {
      if (obs) obs.observe(drawer, { childList: true, subtree: true });
    }
  }

  var pending = false;
  function reconcile() {
    if (pending) return; pending = true;
    var run = function () { pending = false; inject(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run); else window.setTimeout(run, 16);
  }

  // Delegated interactions (bound once, survive re-renders)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var add = e.target.closest('[data-dx-add]');
    if (add) { e.preventDefault(); addSet(add); return; }
    if (e.target.closest('#dx-disc-apply')) { applyDiscount(); }
  });
  document.addEventListener('click', function (e) {
    var co = e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!co) return;
    var code = ''; try { code = (sessionStorage.getItem('dx_discount') || '').trim(); } catch (x) {}
    if (code) { e.preventDefault(); e.stopPropagation(); window.location.href = ROOT + 'checkout?discount=' + encodeURIComponent(code); }
  }, true);

  function applyDiscount() {
    var input = document.getElementById('dx-disc-input'), msg = document.getElementById('dx-disc-msg');
    if (!input) return;
    var code = input.value.trim();
    try { if (code) sessionStorage.setItem('dx_discount', code); else sessionStorage.removeItem('dx_discount'); } catch (e) {}
    if (msg) { msg.hidden = !code; msg.textContent = code ? ('“' + code + '” will be applied at checkout') : ''; }
  }

  function addSet(btn) {
    var vid = btn.getAttribute('data-dx-add');
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true; btn.textContent = 'Adding…';
    var sections = (drawer && drawer.getSectionsToRender) ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : [];
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: sections, sections_url: window.location.pathname }),
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status) { btn.textContent = 'Unavailable'; return; }
      if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
      else { window.location.href = ROOT + 'cart'; }
    }).catch(function () { window.location.href = ROOT + 'cart'; });
  }

  function boot() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    obs = new MutationObserver(reconcile);
    inject(drawer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
